import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from 'contexts/AppProvider';
import App from './App';
import './index.scss';

ReactDOM.render(
	<AppProvider>
		<App />
	</AppProvider>,
	document.getElementById('root')
);
